<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.rgpd.alerteValidite.title')
        }}</v-list-item-title>
        <v-list-item-subtitle
          >{{ $t('administration.rgpd.alerteValidite.subtitle') }}
          {{ form.selectedDate }}</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-row>
        <v-col cols="12" sm="4">
          <v-select
            return-object
            dense
            filled
            v-model="form.selected"
            :items="dates"
            item-text="libelle"
            label="Période"
            hide-details="auto"
            @change="inputEvent()"
          >
            <template #selection="{item}">
              {{ item.libelle }}
            </template>
          </v-select>
        </v-col>
      </v-row>

      <datasource-table :datasource="datasourceContact" :callRefresh="true">
        <template #item.raisonSociale="{item}">
          <router-link :to="$liens().personneMorale(item.idPersonneMorale)"
            >{{ item.raisonSociale }}
          </router-link>
        </template>

        <template #item.nom="{item}">
          <router-link
            :to="$liens().personnePhysique(item.idPersonnePhysique, item.id)"
          >
            {{ item.nom }}
          </router-link>
        </template>
        <template #item.prenoms="{item}">
          <router-link
            :to="$liens().personnePhysique(item.idPersonnePhysique, item.id)"
          >
            {{ item.prenoms }}
          </router-link>
        </template>

        <template #item.telephone="{item}">
          {{ item.telephone }}
          <v-tooltip v-if="item.telephoneConfidentiel" bottom>
            <template #activator="{ on }">
              <v-icon v-on="on">mdi-eye-off</v-icon>
            </template>
            <span>Confidentiel</span>
          </v-tooltip>
        </template>
        <template #item.dateLimiteValidite="{item}">
          {{ formatDate(item.dateLimiteValidite) }}
        </template>
      </datasource-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import moment from 'moment';

export default {
  props: {},
  beforeMount() {
    this.buildDataSource(this.datesearch);
  },
  mounted() {
    this.datesearch = moment().format('YYYY-MM-DD');
    this.$store.commit('origine/recherche', {
      recherche: 'recherchesimple',
    });
  },
  data() {
    var datesearch;
    var datasourceContact;

    return {
      datasourceContact,
      dates: [
        {
          value: '15D',
          libelle: '15 jours ou moins',
        },
        {
          value: '1M',
          libelle: '1 mois ou moins',
        },
        {
          value: '2M',
          libelle: '2 mois ou moins',
        },
        {
          value: '6M',
          libelle: '6 mois ou moins',
        },
      ],
      form: {
        selected: {
          value: '',
          libelle: '',
        },
        selectedDate: '',
      },
      datesearch,
    };
  },
  methods: {
    buildDataSource(date) {
      this.datasourceContact = new Datasource(`rgpd/contact/expire/${date}`, {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['dateLimiteValidite'],
        descending: [false],
        labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
        args: {},
        fields: [
          {
            value: 'nom',
            sortable: true,
          },
          {
            value: 'prenoms',
            sortable: true,
          },
          {
            value: 'raisonSociale',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
            ),
          },

          {
            value: 'fonction',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
            ),
          },
          {
            value: 'telephone',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
            ),
          },
          {
            value: 'mail',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.mail',
            ),
          },
          {
            value: 'dateLimiteValidite',
            sortable: true,
            text: 'Date limite de validité',
          },
        ],
      });
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null;
    },
    refresh() {
      var tMoment = moment();
      switch (this.form.selected.value) {
        case 'T':
          tMoment = moment();
          break;
        case '15D':
          tMoment = moment().add(15, 'd');
          break;
        case '1M':
          tMoment = moment().add(1, 'M');
          break;
        case '2M':
          tMoment = moment().add(2, 'M');
          break;
        case '6M':
          tMoment = moment().add(6, 'M');
          break;
      }
      this.form.selectedDate = tMoment.format('DD/MM/YYYY');
      this.datesearch = tMoment.format('YYYY-MM-DD');
    },
    inputEvent() {
      this.refresh();
      this.buildDataSource(this.datesearch);
      this.$api(`rgpd/contact/expire/${this.datesearch}`)
        .get()
        .then(this.datasourceContact.debouncedRefresh());
    },
  },
};
</script>
